module.exports = __webpack_public_path__ + "media/images/new/icons/money_big-4c3762d719e13ef4200c6232808c6408.png";